import { post,get,postJson,deleteApi } from '../axios'

/**
 * 评价管理配置
 */

const RESOURCE_BASE_PATH = '/popCommentConfig';

/**
 * 评价管理配置列表
 */
// 类型标志，1自动催评，2好评感谢，3中差评安抚
export const list = p => {
    return get(`${RESOURCE_BASE_PATH}/list`,p);
}

/**
 * 今日实时数据监控
 */
export const realTimeMonitoring = p =>{
    return get(`${RESOURCE_BASE_PATH}/realTimeMonitoring`,p)
}

/**
 * 往日数据监控分析
 */
export const popCommentSmsEffect = p =>{
    return get(`${RESOURCE_BASE_PATH}/popCommentSmsEffect`,p)
}


/**
 * 任务状态
 */
export const updateSwitch = p =>{
    return post(`${RESOURCE_BASE_PATH}/switch/${p.configId}/${p.isOpen}`)
}

/**
 * 任务优先级
 */
export const setSort = p =>{
    return post(`${RESOURCE_BASE_PATH}/sort/${p.configId}/${p.sort}`)
}

/**
 * 删除任务
 */
export const delOrdersCarePop = id =>{
    return deleteApi(`${RESOURCE_BASE_PATH}/${id}`)
}

/**
 * 任务详情
 */
export const OrdersCarePopInfo = id =>{
    return get(`${RESOURCE_BASE_PATH}/${id}`)
}

/**
 * 查询评价短信效果详情
 */
export const getPopCommentInfo = p =>{
    return get(`${RESOURCE_BASE_PATH}/getPopCommentInfo`,p)
}

/**
 * 更新任务
 */
export const insertOrUpdate = p =>{
    return postJson(`${RESOURCE_BASE_PATH}/insertOrUpdate`,p)
}